export default {
    props: {
        pannableKey: {
            type: String,
            default: undefined,
            kComposite: 'pannable.key'
        }, 
        pannableLock: {
            type: String,
            default: undefined,
            kComposite: 'pannable.lock'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Pannable.js